import { groupBy } from "lodash-es";
import type { StandingTransformed } from "~pages/Standings/types/standingTransformed";

export const getGroupStandings = (standings: StandingTransformed[], key: string) => {
  const data = groupBy(standings, key);
  const noKeyData = [...(data.null ?? []), ...(data.undefined ?? [])];
  delete data.null;
  delete data.undefined;
  return { data, noKeyData };
};
